<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Connected Bank Accounts'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'finance-skeleton right-side-scroll-enabled' : 'finance-skeleton'">
    @if (!loaded) {
      @for (i of [1,2,3]; track i) {
        <div class="finance-skeleton sk-card">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px;">
            <ion-skeleton-text [animated]="true" style="width: 45%; height: 20px; border-radius: 4px" />
            <ion-skeleton-text [animated]="true" style="width: 70px; height: 14px; border-radius: 4px" />
          </div>
          @for (j of [1,2,3]; track j) {
            <ion-skeleton-text [animated]="true" style="width: 100%; height: 40px; border-radius: 8px; margin-bottom: 6px;" />
          }
        </div>
      }
    }

    @if (loaded && connections.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No bank accounts connected. Connect one and TIDY will sort its transactions into your P&L.'" />
        </tidy-row>
      </tidy-alert>
    }

    @if (loaded && connections.length > 0) {
      @for (view of connections; track view.account.id) {
        <tidy-card style="width: 100%">
          <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
            <tidy-text
              [header]="view.label"
              [translate]="false" />
            <tidy-text
              [helper]="view.statusLabel" />
          </tidy-row>
          @if (view.isActive) {
            <tidy-card-button (action)="viewTransactions(view)">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/svg/receipt-outline.svg'"
                  class="body-size" />
                <tidy-text [body]="'View Transactions'" />
              </tidy-row>
            </tidy-card-button>
            <tidy-card-button (action)="changeStartDate(view)">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/svg/calendar-outline.svg'"
                  class="body-size" />
                <tidy-text [body]="'Change Start Date'" />
              </tidy-row>
            </tidy-card-button>
            <tidy-card-button (action)="removeAccount(view)" class="no-below-stroke">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/svg/trash-outline.svg'"
                  class="body-size" />
                <tidy-text [body]="'Remove'" />
              </tidy-row>
            </tidy-card-button>
          }
        </tidy-card>
      }
    }

    @if (loaded) {
      <div class="finance-button-row">
        <div class="finance-button-row__button">
          <tidy-button
            [text]="connecting ? 'Connecting…' : 'Add Account'"
            [image]="'assets/img/add-button-white.svg'"
            [action]="boundAddAccount"
            [disabled]="connecting"
            class="primary" />
        </div>
      </div>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
